import { IUntypedCommand, Topics } from '@zaplify/common';

export class DeleteSourceCommand extends IUntypedCommand {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly sourceId: string) {
        super();
    }
}
